<template>
  <b-modal
    id="event-modal"
    :hide-footer="true"
    @hidden="resetModal"
    @shown="onShown"
  >
    <template v-slot:modal-title>
      {{ modalName }}
    </template>
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group
        id="input-group-event"
        label="Event Name"
        label-for="input-event"
      >
        <b-input
          id="input-event"
          v-model="$v.form.name.$model"
          type="text"
          :state="validateState('name')"
          aria-describedby="input-name-live-feedback"
        />
        <b-form-invalid-feedback id="input-name-live-feedback">
          Event name is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-checkbox
        v-if="creationModal !== true"
        v-model="form.hidden"
        size="md"
        class="flex-shrink-0 pt-2"
      >
        Hidden?
      </b-form-checkbox>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          type="submit"
          variant="primary"
        >
          Save
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import validateStateMixin from "../mixins/validateStateMixin"
  import {mapGetters} from "vuex";

  export default {
    name: "EventModal",
    mixins: [validateStateMixin],
    props: ['item'],
    computed: {
      ...mapGetters(['selectedHeaderEvent']),
    },
    data() {
      return {
        form: {
          name: "",
          hidden: false
        },
        show: true,
        modalName: 'New Event',
        creationModal: true,
      };
    },
    validations: {
      form: {
        name: {
          required,
        }
      }
    },
    methods: {
      onShown() {
        if (this.item) {
          this.creationModal = false;
          this.modalName = this.item.name;
          this.form.name = this.item.name;
          this.form.hidden = this.item.hidden;
          return;
        }
        this.creationModal = true;
        this.modalName = 'New Event';
        this.form.name = '';
        this.form.hidden = false;
      },
      async onSubmit(evt) {
        evt.preventDefault();
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }
        if (this.creationModal) {
          try{
            await this.$http.post('events', this.form);
            this.successAlert('Event was successfully created.')
          }catch(error){
            this.handleErrorResponse(error);
          }
        } else {
          try{
            await this.$http.put(`events/${this.item.id}`, this.form);
          }catch(error){
            this.handleErrorResponse(error);
          }
        }
        this.$bvModal.hide("event-modal")
      },
      resetModal() {
        this.form.name = '';
        this.form.hidden = false;
        this.$v.$reset();
        this.$emit("close")
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>
